<form>
  <mat-dialog-content class="!grid">
    <p class="dialog-title pt-0">Cancelar Entregable</p>
    <hr class="dialog-divider" />
    <p class="dialog-subtitle">SELECCIONA ENTREGABLES A CANCELAR</p>

    <div class="">
      @for (entregable of entregables; track $index) {
      <div class="flex justify-between items-center">
        <p class="grow !truncate !text-balance list-item">
          {{
            entregable.nombreEntregable
              ? entregable.nombreEntregable
              : "Adjuntar Archivo"
          }}
        </p>
        <mat-checkbox
          [color]="'primary'"
          [(ngModel)]="entregables[$index].selected"
          (change)="updateSelectAllState()"
          name="entregables_{{ $index }}"
          class="example-margin"></mat-checkbox>
      </div>
      }
      <div class="flex justify-between items-center !mb-5">
        <p class="select-all">Seleccionar todos</p>
        <mat-checkbox
          [color]="'warn'"
          name="selectAllChecked"
          [(ngModel)]="selectAllChecked"
          (change)="selectAll($event.checked)"
          class="example-margin"></mat-checkbox>
      </div>
    </div>
    <mat-form-field class="!grow">
      <mat-label>Motivo de cancelación</mat-label>
      <mat-select
        name="motivoJustificacion"
        [formControl]="motivoJustificacion">
        @for (item of catJustificacion; track item) {
        <mat-option [value]="item.descripcion">{{
          item.descripcion
        }}</mat-option>
        }
      </mat-select>
      @if(motivoJustificacion.hasError('required')&&motivoJustificacion.touched)
      {
      <mat-error>Campo obligatorio</mat-error>
      }
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions class="!justify-end">
    <button
      class="uppercase-button"
      mat-raised-button
      [mat-dialog-close]="false">
      CANCELAR
    </button>
    <button
      mat-flat-button
      [color]="'primary'"
      [disabled]="
        motivoJustificacion.invalid || getEntregaablesChecked().length <= 0
      "
      (click)="save()">
      ACEPTAR
    </button>
  </mat-dialog-actions>
</form>
